<style scoped="scoped" lang="scss">
.standard-print-dialog .el-dialog {
  .el-dialog__body {
    max-height:none;
  }
}
._printContent /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: black;
  display: inline-block;
  font-size: 14px;
  outline: none;
  padding: 0 10px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100px;
  line-height: 18px;
  height: 20px;
  font-family: '微软雅黑';
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/print/record/page" getKey="rows" :columns="columns" @selectionChange="selectionChange">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yewuleixing')">
            <yi_dictionary_select :max="999" multiple clearable :type="'BUSINESS_TYPE'" :ids.sync="yt.conditions.businessTypes"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('biaoqqiantiaoma')">
            <el-input v-model="yt.conditions.labelBarcodeNumber"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('dangqianshunxu')">
            <el-input v-model="yt.conditions.currentOrder"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shengchanzhuangtai')">
            <yi_dictionary_select :max="1" clearable :type="'LABEL_PRODUCTION_STATUS'" :ids.sync="yt.conditions.productionStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zhijianzhuangtai')">
            <yi_dictionary_select :max="1" clearable :type="'LABEL_QUALITY_CHECK_STATUS'" :ids.sync="yt.conditions.qualityCheckStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('rukuzhuangtai')">
            <yi_dictionary_select :max="1" clearable :type="'LABEL_STORAGE_STATUS'" :ids.sync="yt.conditions.storageStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('youxiaozhuangtai')">
            <yi_dictionary_select :max="1" clearable :type="'LABEL_VALID_STATUS'" :ids.sync="yt.conditions.validStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dayinshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd" :placeholder="$t('xuanzeriqiheshijian')"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('zhichenggongyi')">
            <yi_dictionary_select :multiple="true" :max="99" clearable :type="'MANUFACTURING_PROCESS'" :ids.sync="yt.conditions.manufacturingProcessList"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('zuzhuangguanlianbianma')">
            <el-input v-model="yt.conditions.assembleAssociateCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('baozhuangshuliangweiling')">
            <el-switch v-model="yt.conditions.packageNumberIsZero" @change="packageNumberSwitch"></el-switch>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({createTimeStart: begin(),createTimeEnd:end(),orderBy:'createTime desc'})">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <!--审核成功-->
        <el-button v-if="utils.checkPower('web_base_label_management_print_record_invalidate')" size="mini" type="danger" @click="invalidateRecords" :loading="invalidateRecordsLoading" :disabled="ids.length <= 0">
          {{ $t('zuofei') }}
        </el-button>
        <!--批量重新打印-->
        <el-button v-if="utils.checkPower('web_base_label_management_print_record_batchReprint')" size="mini" @click="standardBatchReprintValidate" type="primary" :loading="batchReprintLoading" :disabled="printObjList.length <= 0">
          {{ $t('piliangchongxindayin') }}
        </el-button>
        <!--批量重新打印(维尔)-->
        <el-button v-if="utils.checkPower('web_base_label_management_print_record_weier_batchReprint')" size="mini" @click="weierBatchReprintValidate" type="primary" :loading="batchReprintLoading" :disabled="printObjList.length <= 0">
          {{ $t('piliangchongxindayin(weier)') }}
        </el-button>
        <!--已生产标签作废-->
        <el-button v-if="utils.checkPower('web_base_label_management_print_record_invalidateProducedLabel')" size="mini" type="danger" @click="invalidateProducedRecords" :loading="invalidateRecordsLoading" :disabled="ids.length <= 0">
          {{ $t('yishengchanbiaoqianzuofei') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.businessType !== '11'">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click.native.stop="rePrint(scope.row)"><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.businessType === '11' && utils.checkPower('web_base_label_management_print_record_ruike_reprint')">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click.native.stop="reprintRuike(scope.row)"><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.businessType === '11' && utils.checkPower('web_base_label_management_print_record_weier_reprint')">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click.native.stop="weierReprint(scope.row)"><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.businessType === '11' && utils.checkPower('web_base_label_management_print_record_standard_reprint')">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click.native.stop="standardReprint(scope.row)"><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.businessType === '11' && utils.checkPower('web_base_label_management_print_record_yongxin_reprint')">
            <el-button type="text" :loading="scope.row.rePrintLoading" @click.native.stop="yongxinReprint(scope.row)"><!-- 因为有selectionChange所以@click要换成@click.native.stop-->
              {{ $t('chongxindayin') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t('dayinbiaoqian')" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 重新打印 -->
      <template v-if="yt.editObj.action == 'chongxindayin'">
        <div>
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('yewuleixing')" required>
              <yi_dictionary_select :max="999" clearable :type="'PRINT_WARE_HOUSE_TAG_TYPE'" :ids.sync="rePrintObj.businessType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item v-if="rePrintObj.businessType === '1'" :label="$t('xuanzecangku')" required>
              <yi_data_select key="1" multiple :checkStrictly="false" :warehouseLevel="0" type="warehouse" :ids.sync="rePrintObj.areaIdList"> </yi_data_select>
            </el-form-item>
            <el-form-item v-if="rePrintObj.businessType == '2'" :label="$t('xuanzekuqu')" required>
              <yi_data_select key="2" multiple :checkStrictly="false" :warehouseLevel="1" type="warehouse" :ids.sync="rePrintObj.areaIdList"> </yi_data_select>
            </el-form-item>
            <el-form-item v-if="rePrintObj.businessType == '3'" :label="$t('xuanzekuwei')" required>
              <yi_data_select key="3" multiple :checkStrictly="false" :warehouseLevel="2" type="warehouse" :ids.sync="rePrintObj.areaIdList"> </yi_data_select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" type="primary" @click="dayin()">
            {{ $t('dayin') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :show-close="true" :visible.sync="isShowPrintDialog" width="960px" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-scroller" v-if="isShowPrintDialog">
        <template_without_in id="withoutInPrintId" v-if="rePrintObj.businessType === '9'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_without_in>
        <template_deliver_out id="deliverOutPrintId" v-if="rePrintObj.businessType === '8'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_deliver_out>
        <template_without_out id="withOutPrintId" v-if="rePrintObj.businessType === '10'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_without_out>
        <template_purchase_in id="purchaseInPrintId" v-if="rePrintObj.businessType === '7'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_purchase_in>
        <template_product_out id="productOutPrintId" v-if="rePrintObj.businessType === '6'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_product_out>
        <template_product_in id="productInPrintId" v-if="rePrintObj.businessType === '5'" :config="rePrintObj.template.config" :order="rePrintObj.p"> </template_product_in>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowPrintDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="dayin()" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 仓库标签打印 -->
    <div class="dialog-scroller" v-if="yt.isShowEditDialog">
      <div style="display: flex;flex-flow: wrap;" id="warehouseModelListPrint">
        <div v-for="id in rePrintObj.areaIdList" v-if="makeWarehouseTitle(id)">
          <div style="text-align: center;">
            <vue-qr :text="rePrintObj.businessType - 1 + '_' + (id + '').slice(1)" :margin="20" :size="180"></vue-qr>
            <div>{{ makeWarehouseTitle(id) }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 瑞柯重新打印 -->
    <el-dialog :title="$t('chongxindayin')" :visible.sync="isShowRuikePrintLabel" append-to-body="append-to-body" width="350px">
      <div v-if="isShowRuikePrintLabel" style="margin-top: 30px;">
        <el-form :inline="true" ref="form" size="mini" label-width="0px">
          <el-form-item>
            <div id="printContent" style="height: 280px;width: 300px;" class="printFontFamily">
              <div style="display: flex;color: black;">
                <div style="width:50%;">
                  <div style="display:flex;border-top: 1px solid black;border-left: 1px solid black;">
                    <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('xiangmuhao') }}</div>
                    <div style="width:70%;text-align: center;">{{ ruikePrintWo.material.code }}</div>
                  </div>
                  <div style="display:flex;border-top: 1px solid black;border-left: 1px solid black;">
                    <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('pinming') }}</div>
                    <div style="width:70%;text-align: center;">{{ ruikePrintWo.material.name }}</div>
                  </div>
                  <div style="display:flex;border-top: 1px solid black;border-left: 1px solid black;">
                    <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('riqi') }}</div>
                    <div style="width:70%;text-align: center;">{{ dayjs().format('YYYY-MM-DD') }}</div>
                  </div>
                  <div style="display:flex;border-top: 1px solid black;border-left: 1px solid black;">
                    <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('jitaihao') }}</div>
                    <div style="width:70%;text-align: center;">{{ ruikePrintWo.equipment.name }}</div>
                  </div>
                  <div style="display:flex;border-top: 1px solid black;border-left: 1px solid black;">
                    <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('moju') }}</div>
                    <div style="width:70%;text-align: center;">{{ ruikePrintWo.mould.no }}</div>
                  </div>
                </div>
                <div style="width:50%;border: 1px solid black;border-bottom: 1px solid white;">
                  <div v-if="ruikePrintObj.labelBarcodeNumber" style="margin: 15px 0 0 18px;">
                    <vue-qr :text="ruikePrintObj.labelBarcodeNumber" :margin="0" :size="110"></vue-qr>
                  </div>
                </div>
              </div>
              <div style="display: flex;border: 1px solid black;border-bottom: 0px solid white;color: black;">
                <div style="width:50%;display:flex;">
                  <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('shuliang') }}</div>
                  <div style="width:70%;text-align: center;">{{ ruikePrintObj.packageNumber }}</div>
                </div>
                <div style="width:50%;display:flex;">
                  <div style="width:30%;text-align: center;border-left: 1px solid black;border-right: 1px solid black;">{{ $t('picihao') }}</div>
                  <div style="width:70%;text-align: center;">{{ ruikePrintObj.batchNo }}</div>
                </div>
              </div>
              <div style="display: flex;border: 1px solid black;color: black;">
                <div style="width:50%;display:flex;">
                  <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('biaoqianhao') }}</div>
                  <div style="width:70%;text-align: center;">{{ ruikePrintObj.labelBarcodeNumber }}</div>
                </div>
                <div style="width:50%;display:flex;">
                  <div style="width:30%;text-align: center;border-left: 1px solid black;border-right: 1px solid black;">{{ $t('shengchangongdanhao') }}</div>
                  <div style="width:70%;text-align: center;">{{ ruikePrintObj.woNo }}</div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowRuikePrintLabel = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="ruikePrint()" type="primary">
          {{ $t('dayin') }}
        </el-button>
      </span>
    </el-dialog>
    <!-- 标准重新打印 -->
    <el-dialog class="standard-print-dialog" @close="closeStandardPrintDialog" :visible.sync="isShowStandardPrintLabel" append-to-body="append-to-body" width="800px">
      <div v-if="isShowStandardPrintLabel">
        <el-form :inline="true" ref="form" size="mini" label-width="150px">
          <el-form-item :label="$t('dayinmobanmingcheng')" required>
            <el-select @change="printTemplateChange" v-model="printTemplateId" placeholder="请选择">
              <el-option v-for="printTemplate in printTemplateList" :label="printTemplate.name" :value="printTemplate.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <yi_print_preview v-if="printTemplateId" :printTemplateId.sync="printTemplateId" :scale="4" :printDatas="printDatas" ref="yiPrintPreview"></yi_print_preview>
        <div style="text-align: center;padding: 20px 0;">
          <el-button :loading="printLoading" @click="closeStandardPrintDialog" style="width: 130px;">{{ $t('quxiao') }}</el-button>
          <el-button :loading="printLoading" type="primary" @click="standardPrint" style="width: 130px;">{{ $t('dayin') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 永欣重新打印 -->
    <el-dialog class="printDialog" :show-close="false" :visible.sync="isShowYongxinPrintDialog" width="400px" style="height: 480px;">
      <div v-if="isShowYongxinPrintDialog" style="height: 300px;width: 350px;">
        <div id="yongxinPrintContent" style="height: 300px;" class="printFontFamily _printContent">
          <div>
            <div style="display: flex;">
              <div>
                <div style="font-size: 28px;color: black;" class="printFontFamily">制 品 流 转 单</div>
                <div style="font-size: 18px;color: black;" class="printFontFamily">永欣塑业科技有限公司</div>
              </div>
              <div v-if="printObj.labelBarcodeNumber" style="position: absolute;right: 80px;">
                <vue-qr :text="printObj.labelBarcodeNumber" :margin="0" :size="60"></vue-qr>
              </div>
            </div>
            <div style="display:flex;border-top: 1px solid black;border-bottom: 1px solid black;margin-top: 10px;">
              <div style="display:flex;width: 100%;">
                <div style="font-size: 14px;color: black;width: 50%;" class="printFontFamily">{{ $t('dayinren') }}:{{ store.state.user.nickname }}</div>
                <div style="font-size: 14px;color: black;width: 50%;" class="printFontFamily">{{ store.state.currentTime }}</div>
              </div>
            </div>
            <div style="color: black;display: flex;margin-top:5px;">
              <div style="border-right:1px solid black;width: 50%;">
                <div style="border-bottom: 1px solid black;">
                  <div style="font-size: 14px;">{{ $t('chanpinmingcheng') }}</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.material.name }}</div>
                </div>
                <div style="border-bottom: 1px solid black;">
                  <div style="font-size: 14px;">{{ $t('renwudanhao') }}</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.no }}</div>
                </div>
                <div>
                  <div style="font-size: 14px;">{{ $t('tiaoma') }}</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.labelBarcodeNumber }}</div>
                </div>
              </div>
              <div style="width: 50%;">
                <div style="border-bottom: 1px solid black;">
                  <div style="font-size: 14px;margin-left: 2px;">{{ $t('shebeimingcheng') }}</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.equipment.name }}</div>
                </div>
                <div style="border-bottom: 1px solid black;">
                  <div style="font-size: 14px;margin-left: 2px;">{{ $t('benbaozhuangshuliang') }}</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.packageNumber }}</div>
                </div>
                <div>
                  <div style="font-size: 14px;margin-left: 2px;">第{{ printObj.currentOrder }}张</div>
                  <div style="font-size: 14px;text-align: center;height: 24px;">{{ printObj.currentOrder }}/{{ printObj.labelTotalNumber }}</div>
                </div>
              </div>
            </div>
            <div style="margin-top:5px;padding-top:10px;display: flex;border-top:1px solid black;justify-content: space-between;">
              <div style="display: flex;">
                <span style="width: 70px;color: black;">{{ $t('shengchanren') }}</span>
                <el-input maxlength="100" v-model="printObj.producer"></el-input>
              </div>
              <div style="display: flex;">
                <span style="width: 90px;color: black;">{{ $t('shengchanshijian') }}</span>
                <el-input maxlength="100" v-model="printObj.produceTime"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;padding-bottom: 10px">
        <el-button @click="cancelPrint" style="width: 130px;">{{ $t('quxiao') }}</el-button>
        <el-button @click="dayinYongxin" style="width: 130px;background-color: #646566;color: white;">{{ $t('dayin') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import html2canvas from 'html2canvas';
import print from 'print-js';
import VueQr from 'vue-qr';
import template_deliver_out from '@@/pages/web/base/print/template_deliver_out';
import template_without_in from '@@/pages/web/base/print/template_without_in';
import template_without_out from '@@/pages/web/base/print/template_without_out';
import template_purchase_in from '@@/pages/web/base/print/template_purchase_in';
import template_product_out from '@@/pages/web/base/print/template_product_out';
import template_product_in from '@@/pages/web/base/print/template_product_in';

export default {
  name: 'web_label_management_label_record_list',
  components: {
    VueQr,
    template_deliver_out,
    template_without_in,
    template_without_out,
    template_purchase_in,
    template_product_out,
    template_product_in
  },
  data() {
    return {
      ids: [],
      printObjList: [],
      printRecordList: [],
      invalidateRecordsLoading: false,
      rePrintObj: {},
      isShowPrintDialog: false,
      isShowRuikePrintLabel: false,
      ruikePrintObj: {},
      ruikePrintWo: {},
      isShowStandardPrintLabel: false,
      isShowYongxinPrintDialog: false,
      printObj: {},
      printTemplateList: [],
      printDatas: [],
      printTemplateId: null,
      printLoading: false,
      batchReprintLoading: false,
      isBatch: false,
      columns: [
        {
          label: 'xuanze',
          type: 'selection'
        },
        {
          label: 'yewuleixing',
          prop: 'businessType',
          type: 'dictionary',
          key: 'BUSINESS_TYPE',
          width: 150
        },
        {
          label: 'biaoqqiantiaoma',
          prop: 'labelBarcodeNumber',
          width: 150
        },
        {
          label: 'shengchangongdanhao',
          prop: 'woNo',
          width: 150
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 150
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 150
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'baozhuangshuliang',
          prop: 'packageNumber',
          width: 130
        },
        {
          label: 'yitouliaoshuliang',
          prop: 'feedAlready',
          width: 130
        },
        {
          label: 'biaoqianzongshu',
          prop: 'labelTotalNumber',
          width: 150
        },
        {
          label: 'dangqianshunxu',
          prop: 'currentOrder',
          width: 150
        },
        {
          label: 'picihao',
          prop: 'batchNo',
          width: 150
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'goodQuantity',
          width: 150
        },
        {
          label: 'shengchanzhuangtai',
          prop: 'productionStatus',
          type: 'dictionary_tag',
          key: 'LABEL_PRODUCTION_STATUS'
        },
        {
          label: 'zhijianzhuangtai',
          prop: 'qualityCheckStatus',
          type: 'dictionary_tag',
          key: 'LABEL_QUALITY_CHECK_STATUS'
        },
        {
          label: 'rukuzhuangtai',
          prop: 'storageStatus',
          type: 'dictionary_tag',
          key: 'LABEL_STORAGE_STATUS'
        },
        {
          label: 'youxiaozhuangtai',
          prop: 'validStatus',
          type: 'dictionary_tag',
          key: 'LABEL_VALID_STATUS'
        },
        {
          label: 'dayinmoban',
          prop: 'templateName',
          width: 180
        },
        {
          label: 'suoxuancangku/kuqu/kuwei',
          prop: 'areaNames'
        },
        {
          label: 'rukudanhao',
          prop: 'inOrderNo',
          width: 150
        },
        {
          label: 'chukudanhao',
          prop: 'outOrderNo',
          width: 150
        },
        {
          label: 'zuoyeyuan',
          prop: 'customOperator',
        },
        {
          label: 'dayinren',
          prop: 'createByObject.nickname',
          width: 150
        },
        {
          label: 'dayinshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'zhichenggongyi',
          prop: 'wo.manufacturingProcess',
          type: 'dictionary',
          key: 'MANUFACTURING_PROCESS',
          width: 130
        },
        {
          label: 'zuzhuangguanlianbianma',
          prop: 'assembleAssociateCode',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, 'createTimeStart', this.begin())
      this.$set(this.yt.conditions, 'createTimeEnd', this.end())
      this.yt.get(1);
    }, 300);
  },
  computed: {
    makeWarehouseTitle() {
      return id => {
        let title = [];
        if (this.rePrintObj.businessType == 1) {
          for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            if (warehouse.id == id) {
              title[0] = warehouse.code;
              break;
            }
          }

          if (title.length != 1) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        } else if (this.rePrintObj.businessType == 2) {
          A: for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            title[0] = warehouse.code;

            if (warehouse.children) {
              for (let j = 0; j < warehouse.children.length; j++) {
                if (warehouse.children[j].id == id) {
                  title[1] = warehouse.children[j].code;
                  break A;
                }
              }
            }
          }
          if (title.length != 2) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        } else if (this.rePrintObj.businessType == 3) {
          A: for (let i = 0; i < this.store.state.warehouses.length; i++) {
            let warehouse = this.store.state.warehouses[i];
            title[0] = warehouse.code;
            if (warehouse.children) {
              for (let j = 0; j < warehouse.children.length; j++) {
                title[1] = warehouse.children[j].code;

                if (warehouse.children[j].children) {
                  for (let k = 0; k < warehouse.children[j].children.length; k++) {
                    if (warehouse.children[j].children[k].id == id) {
                      title[2] = warehouse.children[j].children[k].code;
                      break A;
                    }
                  }
                }
              }
            }
          }
          if (title.length != 3) {
            return false; //false代表选了类型不对的，因为选择库位的时候，空仓库也是可选的
          }
        }

        return title.join('-');
      };
    }
  },
  methods: {
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end
    },
    async rePrint(row) {
      this.rePrintObj = this.utils.copy(row);
      // 仓库标签
      if (['1', '2', '3'].indexOf(row.businessType) > -1) {
        return this.yt.showEditDialog('chongxindayin', row, 'w1');
      } else {
        this.$set(row, 'rePrintLoading', true);
        if (['5', '7', '9'].indexOf(row.businessType) > -1) {
          // 入库单
          const res = await this.http.get(`/web/in/order/page?pageNum=1&pageSize=1&no=${row.inOrderNo}`);
          if (res.data.rows.length === 1 && res.data.rows[0].id) {
            const res2 = await this.http.get(`/web/in/order/detail/page?pageNum=1&pageSize=1000&inOrderId=${res.data.rows[0].id}`);
            if (res2.code === 200) {
              this.rePrintObj.p = res.data.rows[0];
              this.rePrintObj.p.details = res2.data.rows;
              this.isShowPrintDialog = true;
            } else {
              this.isShowPrintDialog = false;
            }
          }
        } else if (['6', '8', '10'].indexOf(row.businessType) > -1) {
          // 出库单
          const res = await this.http.get(`/web/out/order/page?pageNum=1&pageSize=1&no=${row.outOrderNo}`);
          if (res.data.rows.length === 1 && res.data.rows[0].id) {
            const res2 = await this.http.get(`/web/out/order/detail/page?pageNum=1&pageSize=1000&outOrderId=${res.data.rows[0].id}`);
            if (res2.code === 200) {
              this.rePrintObj.p = res.data.rows[0];
              this.rePrintObj.p.details = res2.data.rows;
              this.isShowPrintDialog = true;
            } else {
              this.isShowPrintDialog = false;
            }
          }
        }
        this.$set(row, 'rePrintLoading', false);
      }
    },

    dayin() {
      const type = this.rePrintObj.businessType;
      let domSrc;
      switch (type) {
        case '1':
        case '2':
        case '3':
          domSrc = document.getElementById('warehouseModelListPrint');
          break;
        case '5':
          domSrc = document.getElementById('productInPrintId');
          break;
        case '6':
          domSrc = document.getElementById('productOutPrintId');
          break;
        case '7':
          domSrc = document.getElementById('purchaseInPrintId');
          break;
        case '8':
          domSrc = document.getElementById('deliverOutPrintId');
          break;
        case '9':
          domSrc = document.getElementById('withoutInPrintId');
          break;
        case '10':
          domSrc = document.getElementById('withOutPrintId');
          break;

        default:
          break;
      }

      html2canvas(domSrc).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
          // footer: "My Footer Text"
        });
        // 新增打印记录
        const res = await this.http.post('/web/print/record/createPrintRecord', this.rePrintObj);
        if (res.code === 200) {
          this.isShowPrintDialog = false;
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        }
      });
    },
    selectionChange(items) {
      this.ids = items.map(item => {
        return item.id;
      });
      this.printObjList = items;
      if (this.ids.length > 0) {
        this.checkDisabled = false;
        for (let i = 0; i < items.length; i++) {
          if (items[i]['status'] == 2) {
            this.checkDisabled = true;
            return;
          }
        }
        this.checkDisabled = false;
      } else {
        this.checkDisabled = true;
        this.printObjList = [];
      }
    },
    //作废
    invalidateRecords() {
      this.invalidateRecordsLoading = true;
      let params = {
        ids: this.ids
      };
      this.http
        .post('/web/print/record/invalidate', params)
        .then(res => {
          this.invalidateRecordsLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.checkDisabled = true;
          this.yt.get(1);
        })
        .catch(error => {
          this.invalidateRecordsLoading = false;
          this.utils.errorMessage(this.$t(error));
        });
    },
    packageNumberSwitch(value) {
      if (value === true) {
        this.yt.conditions.packageNumber = 0;
      } else {
        this.yt.conditions.packageNumber = null;
      }
    },
    reprintRuike(row) {
      this.ruikePrintObj = this.utils.copy(row);
      this.http
        .post('/web/print/record/getReprintWo', { woId: this.ruikePrintObj.woId })
        .then(res => {
          this.ruikePrintWo = res.data;
          this.isShowRuikePrintLabel = true;
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    closeRuikePrintLabel() {
      this.isShowRuikePrintLabel = false;
    },
    ruikePrint() {
      let domSrc = document.getElementById('printContent');
      html2canvas(domSrc, { width: 305, margin: 0, padding: 0 }).then(async canvas => {
        let imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
        });
        // 新增打印记录
        let res = await this.http.post('/web/print/record/reprint', this.ruikePrintObj);
        if (res.code == 200) {
          this.isShowRuikePrintLabel = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    standardReprint(row) {
      this.isBatch = false;
      this.standardPrintObj = this.utils.copy(row);
      //获取打印模板列表
      this.http.get('/web/production/wo/get?id=' + this.standardPrintObj.woId).then(res => {
        this.http.post('/web/print/template/listPrintTemplate', res.data).then(res2 => {
          this.printTemplateList = res2.data;
          for(let i = 0; i < res2.data.length; i++){
            if(res2.data[i].printTemplateType=='2'){
              this.$set(this, 'printTemplateId', res2.data[i].id);
              break;
            }
          }
        });
      });
      //获取标签内容
      this.http.post('/web/print/record/getStandardReprint', this.standardPrintObj).then(res => {
        this.standardPrintObj = res.data;
        this.printDatas.push(this.standardPrintObj.printData);
        this.isShowStandardPrintLabel = true;
      }).catch(err => {
        this.$message.error(err);
      });
    },
    standardBatchReprintValidate(){
      this.isBatch = true;
      if(this.printObjList != null && this.printObjList.length > 0){
        if(this.printObjList.length > 50) {
          this.$message.error(this.$t('dayu50tiaoshujubunengpiliangdayin'));
          this.batchReprintLoading = false;
          return;
        }
        let woId = this.printObjList[0].woId;
        for (let printObject of this.printObjList) {
          if(printObject.woId != woId){
            this.$message.error(this.$t('gouxuanshujudeshengchangongdanhaobuyizhi'));
            this.batchReprintLoading = false;
            return;
          }
        }
        this.batchReprintLoading = true;
        setTimeout(() => {
          //获取打印模板列表
          this.http.get('/web/production/wo/get?id=' + this.printObjList[0].woId).then(res => {
            this.http.post('/web/print/template/listPrintTemplate', res.data).then(res2 => {
              this.printTemplateList = res2.data;
              for(let i = 0; i < res2.data.length; i++){
                if(res2.data[i].printTemplateType=='2'){
                  this.$set(this, 'printTemplateId', res2.data[i].id);
                  break;
                }
              }
            });
          });
          //获取标签内容
          this.http.post('/web/print/record/getStandardBatchReprint', this.printObjList).then(res => {
            this.printDatas = [];
            this.printRecordList = [];
            for (let item of res.data) {
              let print = this.utils.copy(item);
              print.templateId = this.printTemplateId;
              this.printRecordList.push(print);
              let printDataTemp = this.utils.copy(item.printData);
              printDataTemp.labelBarcodeNumber = item.labelBarcodeNumber;
              printDataTemp.cartonNumber = item.labelBarcodeNumber;//维尔箱号=条码号
              printDataTemp.cartonQuantity = item.currentOrder;
              printDataTemp.customOperator = item.customOperator;
              printDataTemp.customShift = item.customShift;
              this.printDatas.push(printDataTemp);
            }
            this.isShowStandardPrintLabel = true;
          }).catch(err => {
            this.$message.error(err);
          });
        }, 300);
      }else{
        this.$message.error(this.$t('qingxuanze'));
        return;
      }
    },
    weierBatchReprintValidate(){
      this.isBatch = true;
      if(this.printObjList != null && this.printObjList.length > 0){
        if(this.printObjList.length > 50) {
          this.$message.error(this.$t('dayu50tiaoshujubunengpiliangdayin'));
          this.batchReprintLoading = false;
          return;
        }
        let woId = this.printObjList[0].woId;
        for (let printObject of this.printObjList) {
          if(printObject.woId != woId){
            this.$message.error(this.$t('gouxuanshujudeshengchangongdanhaobuyizhi'));
            this.batchReprintLoading = false;
            return;
          }
        }
        this.batchReprintLoading = true;
        setTimeout(() => {
          //获取打印模板列表
          this.http.get('/web/production/wo/get?id=' + this.printObjList[0].woId).then(res => {
            this.http.post('/web/print/template/listWeierPrintTemplate', res.data).then(res2 => {
              this.printTemplateList = res2.data;
              for(let i = 0; i < res2.data.length; i++){
                if(res2.data[i].printTemplateType=='2'){
                  this.$set(this, 'printTemplateId', res2.data[i].id);
                  break;
                }
              }
              if(this.printTemplateId == null){
                this.$set(this, 'printTemplateId', res2.data[0].id);
              }
            });
          });
          //获取标签内容
          this.http.post('/web/print/record/getStandardBatchReprint', this.printObjList).then(res => {
            this.printDatas = [];
            this.printRecordList = [];
            for (let item of res.data) {
              let print = this.utils.copy(item);
              print.templateId = this.printTemplateId;
              this.printRecordList.push(print);
              let printDataTemp = this.utils.copy(item.printData);
              printDataTemp.labelBarcodeNumber = item.labelBarcodeNumber;
              printDataTemp.cartonNumber = item.labelBarcodeNumber;//维尔箱号=条码号
              printDataTemp.cartonQuantity = item.currentOrder;
              this.printDatas.push(printDataTemp);
            }
            this.isShowStandardPrintLabel = true;
          }).catch(err => {
            this.$message.error(err);
          });
        }, 300);
      }else{
        this.$message.error(this.$t('qingxuanze'));
        return;
      }
    },
    weierReprint(row) {
      this.isBatch = false;
      this.standardPrintObj = this.utils.copy(row);
      //获取打印模板列表
      this.http.get('/web/production/wo/get?id=' + this.standardPrintObj.woId).then(res => {
        this.http.post('/web/print/template/listWeierPrintTemplate', res.data).then(res2 => {
          this.printTemplateList = res2.data;
          for(let i = 0; i < res2.data.length; i++){
            if(res2.data[i].printTemplateType=='2'){
              this.$set(this, 'printTemplateId', res2.data[i].id);
              break;
            }
          }
          if(this.printTemplateId == null){
            this.$set(this, 'printTemplateId', res2.data[0].id);
          }
        });
      });
      //获取标签内容
      this.http.post('/web/print/record/getStandardReprint', this.standardPrintObj).then(res => {
        this.standardPrintObj = res.data;
        this.printDatas.push(this.standardPrintObj.printData);
        this.isShowStandardPrintLabel = true;
      }).catch(err => {
        this.$message.error(err);
      });
    },
    printTemplateChange() {
      if(!this.isBatch){
        this.printDatas = [];
        this.printDatas.push(this.standardPrintObj.printData);
      }
    },
    closeStandardPrintDialog() {
      this.printLoading = false;
      this.printDatas = [];
      this.standardPrintObj = null;
      this.printTemplateId = null;
      this.isShowStandardPrintLabel = false;
      this.printObjList = [];
      this.printRecordList = [];
      this.ids = [];
      this.batchReprintLoading = false;
      this.yt.get();
    },
    standardPrint() {
      if (!this.printTemplateId) {
        this.$message.error(this.$t('qingxuanzedayinmoban'));
        return;
      }
      this.printLoading = true;
      this.$refs.yiPrintPreview.print();
      // 新增补打记录
      if(this.printObjList.length > 0){
        this.http.post('/web/print/record/standardBatchReprint', this.printRecordList).then(res => {
          this.$message.success(this.$t('chenggong'));
          setTimeout(() => {
            this.printLoading = false;
            this.closeStandardPrintDialog();
          }, 500);
        }).catch(err => {
          this.$message.error(err);
          this.closeStandardPrintDialog();
        });
      }else {
        this.http.post('/web/print/record/reprint', this.standardPrintObj).then(res => {
          this.$message.success(this.$t('chenggong'));
          setTimeout(() => {
            this.printLoading = false;
            this.closeStandardPrintDialog();
          }, 500);
        }).catch(err => {
          this.$message.error(err);
          this.closeStandardPrintDialog();
        });
      }
    },
    dayinYongxin() {
      let domSrc = document.getElementById('yongxinPrintContent');
      html2canvas(domSrc).then(async canvas => {
        const imgData = canvas.toDataURL('image/png');
        print({
          printable: imgData,
          type: 'image',
          documentTitle: '',
          modalMessage: this.$t('zhengzaijiazaiwenjian,qingshaohou')
        });
        this.printObj.businessType = 11;
        this.printObj.woNo = this.printObj.no;
        // 新增打印记录
        let res = await this.http.post('/web/print/record/reprint', this.printObj);
        if (res.code === 200) {
          this.isShowYongxinPrintDialog = false;
        }
      });
    },
    yongxinReprint(printObj) {
      this.printObj = this.utils.copy(printObj);
      this.printObj.equipment = {name: ''};
      if(!this.printObj) {
        this.printObj = {material:{},equipment:{},no:'',packageNumber:'',labelTotalNumber:'',currentOrder:'',labelBarcodeNumber:''};
      }
      this.http.post('/web/print/record/printAgain',{id:printObj.id}).then(res=> {
        this.printObj.material.name = res.data.productName;
        this.printObj.equipment.name = res.data.deviceName;
        this.printObj.no = printObj.woNo;
        this.printObj.packageNumber = printObj.packageNumber;
        this.printObj.labelTotalNumber = printObj.labelTotalNumber;
        this.printObj.currentOrder = printObj.currentOrder;
        this.printObj.labelBarcodeNumber = printObj.labelBarcodeNumber;
        setTimeout(() => {
          this.isShowYongxinPrintDialog = true;
        }, 100);
      });
    },
    cancelPrint() {
      this.isShowYongxinPrintDialog = false;
    },
    invalidateProducedRecords(){
      this.invalidateRecordsLoading = true;
      this.batchReprintLoading = true;
      let params = {
        ids: this.ids
      };
      this.http.post('/web/print/record/invalidateProducedLabel', params).then(res => {
        this.invalidateRecordsLoading = false;
        this.batchReprintLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.ids = [];
        this.yt.get();
      }).catch(error => {
        this.invalidateRecordsLoading = false;
        this.batchReprintLoading = false;
        this.ids = [];
        this.utils.errorMessage(this.$t(error));
      });
    },
  }
};
</script>
